import actionCreatorFactory from "typescript-fsa";


const actionCreator = actionCreatorFactory('routes/login');

export const usernameChanged = actionCreator<string>('USERNAME_CHANGED');
export const passwordChanged = actionCreator<string>('PASSWORD_CHANGED');
export const authProviderChanged =
  actionCreator<string>('AUTH_PROVIDER_CHANGED');

export const loginFormSubmitted = actionCreator('LOGIN_FORM_SUBMITTED');



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/login/Login.actions.ts